import { Injectable, inject } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs/operators';

/** Тот же порог, что и во всех @media в CSS. Единственное место,
 *  где ширина мобильного брейкпоинта задана в TypeScript. */
export const MOBILE_QUERY = '(max-width: 768px)';

/**
 * Мобильный брейкпоинт как сигнал.
 *
 * Раскладка делается на CSS — сюда обращаемся только там, где от ширины
 * зависит НАЧАЛЬНОЕ СОСТОЯНИЕ компонента, а не оформление: например,
 * свёрнута ли панель фильтров при первом рендере. CSS такое выразить не
 * может, потому что состоянием владеет компонент PrimeNG.
 */
@Injectable({ providedIn: 'root' })
export class BreakpointService {
  private readonly observer = inject(BreakpointObserver);

  readonly isMobile = toSignal(
    this.observer.observe(MOBILE_QUERY).pipe(map(state => state.matches)),
    { initialValue: this.observer.isMatched(MOBILE_QUERY) }
  );
}
